export default "__VITE_ASSET__BWKNj9kH__"